import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchOrders = async ({
  page = 1,
  limit = 10,
  filter = null,
  search = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    Object.entries(filter).forEach(([key, value]) => {
      if (!value || value === 'all') return;

      if (Array.isArray(value)) {
        query += `&${key}=${value.map((v) => encodeURIComponent(v)).join(',')}`;
      } else {
        query += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    if (search) {
      query += `&search=${search}`;
    }

    const response = await authClient.get(`/orders${query}`);
    return {
      data: {
        orders: response.data.orders,
        page: response.data.page,
        totalPages: response.data.totalPages,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, error: message };
  }
};

export const markOrderAsPaid = async (orderId) => {
  try {
    const response = await authClient.patch(`/orders/${orderId}/mark-as-paid`);

    return {
      data: {
        order: response.data.order,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Došlo je do greške.');
    return { data: null, error: message };
  }
};

export const fetchUserOrders = async (userId, page = 1, limit = 10) => {
  try {
    const query = `?page=${page}&limit=${limit}`;
    const response = await authClient.get(`/orders/by-user/${userId}${query}`);

    return {
      data: {
        orders: response.data.data.orders,
        pagination: response.data.data.pagination,
        ordersPriceSummary: response.data.data.ordersPriceSummary,
      },
      success: true,
      message: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju narudžbina korisnika.'
    );
    return { data: null, success: false, message };
  }
};

export const exportOrders = async ({
    createdFrom = null,
    createdTo = null,
    status = null,
    agentId = null,
    userId = null,
  }) => {
  try {
    const params = new URLSearchParams();

    if (createdFrom) params.append('createdFrom', createdFrom);
    if (createdTo) params.append('createdTo', createdTo);
    if (status) params.append('status', status);
    if (agentId) params.append('agentId', agentId);
    if (userId) params.append('userId', userId);

    const query = params.toString() ? `?${params.toString()}` : '';

    const response = await authClient.get(`/orders/export${query}`, {
      responseType: 'blob',
    });

    if (response.headers['content-type']?.includes('application/json')) {
      const text = await response.data.text();
      const jsonData = JSON.parse(text);
      return {
        data: null,
        success: jsonData.success,
        message: jsonData.message
      };
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `porudzbine-${status ?? 'sve'}-${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return {
      data: true,
      success: true,
      message: 'Porudžbine uspešno izvezene'
    };
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri izvozu porudžbina.'
    );
    return { data: null, success: false, message: message };
  }
};

